// extracted by mini-css-extract-plugin
export default {"dataTableContainer":"DataTable_dataTableContainer__yDtUL","dataTable":"DataTable_dataTable__mETT4","paginator":"DataTable_paginator__EG35f"};